export const PDFViewerConstants = {
  PAGE_COMPONENT_CLASS: "pageStyling",
  DOC_COMPONENT_CLASS: "documentStyling",
  CANVAS_BACKGROUND_COLOR: "#6f7375",
  LOADING_MESSAGE: "Loading PDF...",
  ERROR_MESSAGE: "Failed to Load",
};
